import { FilmSlate, SquaresFour, UserCircle, Wallet, FileText } from "@phosphor-icons/react";
import type { AgentType } from "@/features/onboarding/agent-type";
import type { WorkbenchIdentity } from "./identity";

export function workbenchNavigation({ identity, agentType, home, avatarEnabled, authorizationEnabled, showProjects = false }: {
  identity: WorkbenchIdentity; agentType?: AgentType | null; home: string; avatarEnabled: boolean; authorizationEnabled: boolean; showProjects?: boolean;
}) {
  const nav = identity === "creator" ? [
    { href: home, label: "总览", icon: SquaresFour },
    { href: avatarEnabled ? "/my-avatars" : "/creator/talents", label: "形象上传", icon: UserCircle },
    ...(authorizationEnabled ? [{ href: "/my-authorizations", label: "授权申请", icon: FileText }] : []),
    { href: "/contracts", label: "合同管理", icon: FileText },
    { href: "/wallet", label: "钱包收益", icon: Wallet },
  ] : identity === "agent" ? [
    { href: home, label: "总览", icon: SquaresFour },
    { href: "/partner/agent/assets", label: "形象资产", icon: UserCircle },
    ...(agentType === "store" ? [] : [
      { href: "/partner/agent/authorizations", label: "授权管理", icon: FileText },
      { href: "/partner/agent/funds", label: "资金流向", icon: Wallet },
    ]),
  ] : [
    { href: home, label: "总览", icon: SquaresFour },
    ...(identity === "brand" || identity === "director" ? [
      { href: "/partner/casting", label: identity === "director" ? "影视选角" : "电商选角", icon: SquaresFour },
      ...(showProjects ? [{ href: "/partner/projects", label: "项目管理", icon: FilmSlate }] : []),
    ] : [{ href: "/plaza", label: "形象广场", icon: SquaresFour }]),
    { href: "/partner/authorizations", label: "授权申请", icon: FileText },
    ...(identity === "brand" || identity === "director" ? [{ href: "/contracts", label: "合同管理", icon: FileText }] : []),
  ];
  nav.push({ href: "/account/profile", label: identity === "creator" ? "个人信息" : "账号设置", icon: UserCircle });
  return nav;
}
